/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('store.parlogis-controls', function (el) {
        var item = new ParalogisProductControls(el);
        item.run();
    });
    var ParalogisProductControls = /** @class */ (function () {
        function ParalogisProductControls(el) {
            this.el = el;
        }
        ParalogisProductControls.prototype.run = function () {
            this.fixOptions();
        };
        ParalogisProductControls.prototype.fixOptions = function () {
            var unit = this.el.querySelector('.qtyWrap label[for="qty"]');
            if (unit) {
                var unitText_1 = unit.textContent;
                this.el.querySelectorAll('.qtyWrap select option').forEach(function (elm) {
                    elm.label = elm.label + ' ' + unitText_1;
                });
            }
        };
        return ParalogisProductControls;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
